export default __webpack_public_path__ + "static/media/softskills.11699819.png";